<div class="form-panel-container">
    @if (!loading) {
        <app-view-accessibilities-management
            [disabled]="disabled"
            [view]="view"
            [originalAccessibilities]="originalAccessibilities"
            [inheritedAccessibilities]="inheritedAccessibilities"
            [accessibilities]="accessibilities"
            [users]="users"
            [unusedUsers]="unusedUsers"
            [groups]="groups"
            [unusedGroups]="unusedGroups"
            (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"></app-view-accessibilities-management>
    }
    <div class="buttons-container">
        @if (!disabled) {
            <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        }
        <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); onExported()">Exporter</button>
        @if (!disabled) {
            <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); fileToUpload.click()">Importer</button>
            <button mat-raised-button class="accent-button" (click)="save()">Enregistrer</button>
        }
        <input ng2FileSelect #fileToUpload class="file-to-upload" type="file" [uploader]="uploader" (change)="onFileSelected()" [hidden]="true" />
    </div>
</div>
